import { SVGProps, Ref, forwardRef } from 'react';

export const DzenBrandSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M7.972 15h.056c2.78 0 4.394-.28 5.537-1.389C14.731 12.434 15 10.81 15 8.04V7.96c0-2.768-.27-4.382-1.435-5.571C12.423 1.28 10.797 1 8.03 1h-.056c-2.78 0-4.395.28-5.538 1.39C1.269 3.567 1 5.193 1 7.96v.079c0 2.768.27 4.382 1.435 5.571 1.132 1.11 2.758 1.39 5.537 1.39"
                fill="#202022"
            />
            <path
                d="M13.333 7.894a.1.1 0 0 0-.097-.1c-1.913-.072-3.078-.316-3.892-1.131-.817-.817-1.06-1.982-1.133-3.9a.1.1 0 0 0-.1-.096h-.223a.1.1 0 0 0-.1.096c-.072 1.917-.316 3.083-1.132 3.9-.815.815-1.98 1.059-3.893 1.131a.1.1 0 0 0-.096.1v.223c0 .054.043.098.096.1 1.914.073 3.078.317 3.893 1.132.815.814 1.058 1.977 1.131 3.887a.1.1 0 0 0 .1.096h.224a.1.1 0 0 0 .1-.096c.074-1.91.317-3.073 1.132-3.887.815-.816 1.98-1.06 3.893-1.132a.1.1 0 0 0 .096-.1z"
                fill="white"
            />
        </g>
    </svg>
));
DzenBrandSize16Glyph.displayName = 'DzenBrandSize16Glyph';
